var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageOk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24531",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24531",
    transform: "translate(-96.5 -95)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_13641",
    "data-name": "\\u9577\\u65B9\\u5F62 13641",
    width: 180,
    height: 180,
    rx: 90,
    transform: "translate(97.5 96)",
    fill: "none",
    stroke: "#a59785",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "done_FILL0_wght400_GRAD0_opsz24",
    d: "M179.877-666.408,154-692.286l6.469-6.469,19.408,19.408L221.531-721,228-714.531Z",
    transform: "translate(-3.106 879.781)",
    fill: "#a59785"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOk);
export default __webpack_public_path__ + "static/media/image_ok.9c44f013938b9e8f118ef32e9ef5fe4e.svg";
export { ForwardRef as ReactComponent };